export enum ValueTypeEnum {
  'number' = 'number',
  'string' = 'string',
  'boolean' = 'boolean',
}
